import React from 'react';
import { Leaf, Check } from 'lucide-react';
import { whyChooseUs, stats } from '../mock';

const WhyChoose = () => {
  return (
    <section className="py-24 bg-[#0b1a1a] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05]"
           style={{ backgroundImage: 'radial-gradient(#10b981 1px, transparent 1px)', backgroundSize: '24px 24px' }} />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-emerald-500/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14">
        <div>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-700 bg-emerald-900/30 text-emerald-300 text-xs font-semibold uppercase tracking-widest">
            <Leaf className="w-3.5 h-3.5" /> Why Choose Us
          </div>
          <h2 className="mt-5 text-4xl md:text-5xl font-extrabold leading-tight">
            Transforming Waste <br />into <span className="text-emerald-400">Clean Energy</span>
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed text-lg">
            India's trusted name in CBG — delivering reliable, eco-friendly energy with proven results across the nation.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur">
                <div className="text-4xl font-extrabold text-emerald-400">{s.value}</div>
                <div className="text-sm text-slate-300 font-semibold mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="space-y-4">
          {whyChooseUs.map((w, i) => (
            <div key={w.title} className="group bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl p-6 flex gap-5 transition-colors">
              <div className="w-12 h-12 shrink-0 rounded-xl bg-emerald-500 grid place-items-center font-extrabold text-lg">
                0{i+1}
              </div>
              <div>
                <h4 className="text-xl font-bold flex items-center gap-2">
                  {w.title}
                  <Check className="w-4 h-4 text-emerald-400" />
                </h4>
                <p className="mt-2 text-slate-300 leading-relaxed">{w.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
